/**
 * Greek Text Utilities
 * Handles proper uppercase conversion for Greek text (removes accents/τόνοι)
 */

// Map of Greek letters with accents to without accents
const greekAccentMap = {
  'ά': 'α', 'Ά': 'Α',
  'έ': 'ε', 'Έ': 'Ε',
  'ή': 'η', 'Ή': 'Η',
  'ί': 'ι', 'Ί': 'Ι', 'ϊ': 'ι', 'ΐ': 'ι', 'Ϊ': 'Ι',
  'ό': 'ο', 'Ό': 'Ο',
  'ύ': 'υ', 'Ύ': 'Υ', 'ϋ': 'υ', 'ΰ': 'υ', 'Ϋ': 'Υ',
  'ώ': 'ω', 'Ώ': 'Ω'
}

/**
 * Remove Greek accents from text
 * @param {string} text - Text to process
 * @returns {string} Text without Greek accents
 */
export function removeGreekAccents(text) {
  if (!text) return text

  return text.split('').map(char => greekAccentMap[char] || char).join('')
}

/**
 * Convert text to uppercase and remove Greek accents
 * @param {string} text - Text to convert
 * @returns {string} Uppercase text without Greek accents
 */
export function toGreekUpperCase(text) {
  if (!text) return text

  // First remove accents, then uppercase
  const withoutAccents = removeGreekAccents(text)
  return withoutAccents.toUpperCase()
}

/**
 * Vue filter for Greek uppercase
 * Use in templates: {{ text | greekUpper }}
 */
export function greekUpperFilter(value) {
  return toGreekUpperCase(value)
}
